<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6">
          Input Nomor Nota
        </v-card-title>

        <v-container>
          <v-text-field
            v-model="formData.nomor_nota"
            label="Nomor Nota"
            outlined
            hide-details
            @keydown.enter="checkNomorNota"
            :disabled="loading"
            :loading="loading"
            autofocus
          ></v-text-field>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "FindNomorNotaModal",
  props: ["openModal"],
  data() {
    return {
      formData: {
        nomor_nota: ""
      },
      loading: false
    };
  },
  watch: {
    openModal(val) {
      if (val) {
        this.formData.nomor_nota = "";
      }
    },
    "formData.nomor_nota"(val) {
      if (val) {
        this.formData.nomor_nota = val.toUpperCase();
      }
    }
  },
  methods: {
    async checkNomorNota() {
      this.loading = true;

      await axios
        .post(`invoice/fetch-invoice`, this.formData)
        .then(res => {
          this.loading = false;

					this.$emit('close-modal', res.data.invoice);
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    }
  }
};
</script>
